import React from 'react';
import { Link } from 'react-router-dom';
import {
  FaGraduationCap,
  FaTwitter,
  FaLinkedinIn,
  FaFacebookF,
  FaEnvelope,
} from 'react-icons/fa';
import './UniversityFooter.css';

const UniversityFooter = () => {
  return (
    <footer className="uni-footer">
      <div className="uni-footer-container">
        <div className="uni-footer-column uni-footer-brand">
          <div className="uni-footer-logo">
            <FaGraduationCap />
            <h3>ULSAAPP University</h3>
          </div>
          <p>AI-powered Virtual University focused on evaluation and certification.</p>
          <p>No fixed syllabus, no regular classes — choose your own subjects and prove your knowledge.</p>
        </div>

        <div className="uni-footer-column">
          <h4>University</h4>
          <ul>
            <li><Link to="/university/subjects">Subjects</Link></li>
            <li><Link to="/university/exam">Start Exam</Link></li>
            <li><Link to="/university/certificates">Certificates</Link></li>
            <li><Link to="/university/analytics">Analytics</Link></li>
            <li><Link to="/university/guide">Help / Guide</Link></li>
          </ul>
        </div>

        <div className="uni-footer-column">
          <h4>Information</h4>
          <ul>
            <li><Link to="/faqs">FAQs</Link></li>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/users-feedback">Feedback</Link></li>
            <li><Link to="/university/privacy-policy">Privacy Policy</Link></li>
            <li><Link to="/university/terms-and-conditions">Terms & Conditions</Link></li>
          </ul>
        </div>

        <div className="uni-footer-column">
          <h4>Contact</h4>
          <p className="uni-footer-contact">
            <FaEnvelope />
            <a href="mailto:support.ulsaapp@atozasindia.in">support.ulsaapp@atozasindia.in</a>
          </p>
          <div className="uni-footer-social">
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter"><FaTwitter /></a>
            <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><FaLinkedinIn /></a>
            <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><FaFacebookF /></a>
          </div>
        </div>
      </div>

      <div className="uni-footer-bottom">
        <p>&copy; {new Date().getFullYear()} ULSAAPP University. All rights reserved.</p>
        <p className="uni-footer-tagline">Fully AI-generated exams & evaluation — no manual interference.</p>
      </div>
    </footer>
  );
};

export default UniversityFooter;
